import Model from 'src/app/common/model';

export default class SrStatusCodesModel extends Model {
  code: string;
  description: string;

  constructor() {
    super();
  }
}
